import React from "react";

const NotFound = (props) => {
  return (
    <p
      style={{
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "3rem",
        marginTop: "1em",
      }}
    >
      404 - Page not found
    </p>
  );
};

export default NotFound;
